{
  "v2.propriete.annuler": "Cancel",
  "v2.propriete.code.COMPTE_DESACTIVE": "The recipient’s account is deactivated or gone.",
  "v2.propriete.code.CONFIRMATION_IDENTITE_ECHOUEE": "Incorrect secret: your identity is not confirmed.",
  "v2.propriete.code.CONFIRMATION_IDENTITE_REQUISE": "Confirm your identity first (valid for 5 minutes).",
  "v2.propriete.code.CONFLIT_CONCURRENT": "Ownership changed in the meantime: it has just been reloaded, check before trying again.",
  "v2.propriete.code.NOM_NE_CORRESPOND_PAS": "The retyped name does not match the organisation’s name.",
  "v2.propriete.code.PROPRIETAIRE_SEUL": "Only the owner can do this.",
  "v2.propriete.code.PROPRIETE_ABSENTE": "This organisation has no recorded owner: report it to the platform administrators.",
  "v2.propriete.code.RESOURCE_UNAVAILABLE": "This space cannot be found or is not accessible.",
  "v2.propriete.code.TRANSFERT_VERS_UN_MEMBRE": "The recipient is not a member: they cannot receive ownership.",
  "v2.propriete.code.TROP_DE_TENTATIVES": "Too many attempts: try again in a few minutes.",
  "v2.propriete.code.USER_NOT_FOUND": "This person cannot be found in the organisation.",
  "v2.propriete.confirmer": "Confirm the transfer",
  "v2.propriete.dialogue.destinataire": "Recipient member",
  "v2.propriete.dialogue.destinataire.aide": "Only active members of the organisation can receive ownership.",
  "v2.propriete.dialogue.destinataire.aucun": "No other active member can receive ownership.",
  "v2.propriete.dialogue.destinataire.choisir": "Choose an active member",
  "v2.propriete.dialogue.destinataire.prerempli": "Member chosen from their record.",
  "v2.propriete.dialogue.destinataire.quoi": "the active members",
  "v2.propriete.dialogue.gardez.admin": "You keep the organisation administrator profile; the new owner may remove it.",
  "v2.propriete.dialogue.gardez.droits": "Your rights are recomputed after the transfer.",
  "v2.propriete.dialogue.gardez.profils": "Your project and programme profiles are kept.",
  "v2.propriete.dialogue.gardez.titre": "What you keep",
  "v2.propriete.dialogue.niveau.programme": "Programme",
  "v2.propriete.dialogue.niveau.projet": "Project",
  "v2.propriete.dialogue.nom": "Organisation name to retype",
  "v2.propriete.dialogue.nom.aide": "Retype “{{nom}}” to confirm.",
  "v2.propriete.dialogue.paiement.texte": "Billing follows the owner: the recipient becomes responsible for it.",
  "v2.propriete.dialogue.paiement.titre": "Payment methods and invoices",
  "v2.propriete.dialogue.recoit.texte": "The ownership link: the rights reserved to the owner (transfer, full export, organisation deletion) and administration of the whole organisation.",
  "v2.propriete.dialogue.recoit.titre": "What the recipient receives",
  "v2.propriete.dialogue.reprendre.quoi": "your ownerships",
  "v2.propriete.dialogue.reprendre.texte": "Before leaving the organisation, also transfer these spaces:",
  "v2.propriete.dialogue.reprendre.titre": "Ownerships to hand over before leaving",
  "v2.propriete.dialogue.titre": "Transfer organisation ownership to a member",
  "v2.propriete.echec": "The transfer did not go through.",
  "v2.propriete.ecran.dialogue-exporter-organisation": "Full organisation export",
  "v2.propriete.ecran.dialogue-quitter-organisation": "Leave the organisation",
  "v2.propriete.ecran.dialogue-supprimer-mon-organisation": "Organisation deletion",
  "v2.propriete.ecran.organisation-export-fiche": "Export record",
  "v2.propriete.ecran.organisation-suppression-fiche": "Organisation deletion request record",
  "v2.propriete.ecran.programme-cycle-de-vie": "Programme lifecycle",
  "v2.propriete.ecran.projet-cycle-de-vie": "Project lifecycle",
  "v2.propriete.espace.aucun": "No other member can receive ownership.",
  "v2.propriete.espace.choisir": "Choose a member",
  "v2.propriete.espace.effets.programme": "You lose descending administration of the programme unless you hold an administration profile there.",
  "v2.propriete.espace.effets.projet": "You keep your project profile.",
  "v2.propriete.espace.effets.reserves": "The new owner holds the rights reserved to the owner.",
  "v2.propriete.espace.effets.titre": "Effects of the transfer",
  "v2.propriete.espace.fait": "Ownership has been transferred to {{nom}}. The transfer is recorded in the log.",
  "v2.propriete.espace.nouveau": "New owner",
  "v2.propriete.espace.programme.aide": "Only programme members can receive ownership.",
  "v2.propriete.espace.programme.quoi": "the programme members",
  "v2.propriete.espace.programme.sans_objet": "No programme given: open this dialog from a programme.",
  "v2.propriete.espace.programme.titre": "Transfer programme ownership",
  "v2.propriete.espace.projet.aide": "Only project members can receive ownership.",
  "v2.propriete.espace.projet.quoi": "the project members",
  "v2.propriete.espace.projet.sans_objet": "No project given: open this dialog from a project.",
  "v2.propriete.espace.projet.titre": "Transfer project ownership",
  "v2.propriete.etat.chargement": "Loading: {{quoi}}…",
  "v2.propriete.etat.en_cours": "Sending…",
  "v2.propriete.etat.erreur": "Unable to read {{quoi}}.",
  "v2.propriete.etat.reessayer": "Retry",
  "v2.propriete.etat.refus": "You do not have access to {{quoi}}.",
  "v2.propriete.organisation.administrateurs.titre": "Administrators",
  "v2.propriete.organisation.administrateurs.vide": "No administrator named: only the owner administers the organisation.",
  "v2.propriete.organisation.cycle.titre": "Lifecycle",
  "v2.propriete.organisation.demander_export": "Request a full export",
  "v2.propriete.organisation.exports.cree": "Requested on {{date}}",
  "v2.propriete.organisation.exports.etat.echec": "Failed",
  "v2.propriete.organisation.exports.etat.en_preparation": "Being prepared",
  "v2.propriete.organisation.exports.etat.expire": "Expired",
  "v2.propriete.organisation.exports.etat.pret": "Ready",
  "v2.propriete.organisation.exports.expire": "Expires on {{date}}",
  "v2.propriete.organisation.exports.quoi": "the organisation’s exports",
  "v2.propriete.organisation.exports.titre": "Full exports",
  "v2.propriete.organisation.exports.vide": "No export requested.",
  "v2.propriete.organisation.identite.description": "Description",
  "v2.propriete.organisation.identite.nom": "Name",
  "v2.propriete.organisation.identite.quoi": "the organisation’s identity",
  "v2.propriete.organisation.identite.sans_description": "No description.",
  "v2.propriete.organisation.identite.statut": "Status",
  "v2.propriete.organisation.identite.titre": "Organisation identity",
  "v2.propriete.organisation.nommer": "Name an administrator",
  "v2.propriete.organisation.onglet.apercu": "Overview",
  "v2.propriete.organisation.onglet.propriete": "Ownership and lifecycle",
  "v2.propriete.organisation.onglets": "Organisation sections",
  "v2.propriete.organisation.proprietaire.nom": "{{nom}} is the owner of this organisation.",
  "v2.propriete.organisation.proprietaire.quoi": "the organisation’s ownership",
  "v2.propriete.organisation.proprietaire.titre": "Current owner",
  "v2.propriete.organisation.proprietaire.vous": "You are the owner of this organisation.",
  "v2.propriete.organisation.quitter": "Leave the organisation",
  "v2.propriete.organisation.quitter.transferer_d_abord": "You are the owner: transfer ownership first.",
  "v2.propriete.organisation.suivre_export": "Follow the export",
  "v2.propriete.organisation.suivre_export_en_cours": "Follow the export in progress",
  "v2.propriete.organisation.suppression.aucune": "No deletion scheduled.",
  "v2.propriete.organisation.suppression.export_en_preparation": "The end-of-life export is being prepared.",
  "v2.propriete.organisation.suppression.export_pret": "The end-of-life export is ready.",
  "v2.propriete.organisation.suppression.le": "Deletion scheduled on {{date}}.",
  "v2.propriete.organisation.suppression.quoi": "the organisation’s lifecycle",
  "v2.propriete.organisation.suppression.titre": "Scheduled deletion",
  "v2.propriete.organisation.supprimer": "Delete the organisation",
  "v2.propriete.organisation.supprimer.deja": "A deletion is already scheduled.",
  "v2.propriete.organisation.titre": "Organisation ownership and lifecycle",
  "v2.propriete.organisation.transferer": "Transfer ownership",
  "v2.propriete.organisation.transferer.aucun_autre_membre": "No other active member: first invite the person who will take over ownership.",
  "v2.propriete.organisation.transferer.suppression_programmee": "The organisation’s deletion is scheduled: cancel it before transferring ownership.",
  "v2.propriete.organisation.transfert.fait": "Ownership has been transferred. You keep your administrator profile.",
  "v2.propriete.organisation.transfert.fait_puis_quitter": "Ownership has been transferred. Leaving the organisation comes with a later wave.",
  "v2.propriete.organisation.voir_demande": "View the deletion request",
  "v2.propriete.puis_quitter": "Transfer then leave",
  "v2.propriete.reauth": "Your password or second factor",
  "v2.propriete.reauth.aide": "Your identity is confirmed just before the transfer (valid for 5 minutes).",
  "v2.propriete.reauth.requis": "Enter your secret to confirm your identity.",
  "v2.propriete.sans_organisation": "No organisation in your session.",
  "v2.propriete.transfert.a_venir": "Ownership transfer comes with a later wave: the gateway does not serve it yet.",
  "v2.propriete.vague_ulterieure": "“{{ecran}}” comes with a later wave: this action is not available yet."
}
